module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hGCIS"))).then(() => module.bundle.root('dJXJK'));